<div class="col-md-12 text-end">
    <div class="activity_title_wrapper d-flex align-items-center justify-content-end w-100">
        <span class="activity_title">Organization Name</span>
        <span class="section-data">{{ currentOrganizationName }}</span>
        <span class="activity_title">Instance Name</span>
        <span class="section-data">{{ currentInstanceName }}</span>
        <span class="activity_title">Asset Type</span>
        <span class="section-data">{{ currentAssetType }}</span>
    </div>
</div>
